<template>
	<div class="relative">
		<SystemError />
		<router-view></router-view>
	</div>
</template>

<script>
import SystemError from '@/components/SystemError';

export default {
	components: {
		SystemError,
	},
};
</script>
